import React from 'react';
import { SearchBoxWithRoundedCorners } from '../../../../components/component-book/components/SearchBox';

type SearchBoxWithRoundedCornersProps = React.ComponentProps<typeof SearchBoxWithRoundedCorners>;

type PropsSet = 'clearButton' | 'icon';
export type SearchBoxFactoryArg = {
  magnifyingGlassSize: { height: string; marginRight: string };
  placeholder: string;
  s3BasePath: string;
  size?: { height: string; width: string };
};

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
export function searchBoxWithRoundedCornersFactory(
  arg: SearchBoxFactoryArg,
): React.FC<Omit<SearchBoxWithRoundedCornersProps, keyof SearchBoxFactoryArg | PropsSet>> {
  const { magnifyingGlassSize, s3BasePath, ...restArg } = arg;
  return props => (
    <SearchBoxWithRoundedCorners
      clearButton={{ hideWhenValueEmpty: true, on: true }}
      icon={{
        active: true,
        node: <img className="icb" src={`${s3BasePath}mkt/header/magnifying_glass.svg`} style={magnifyingGlassSize} />,
        position: 'left' as const,
      }}
      {...restArg}
      {...props}
    />
  );
}
